export const errMsgs = {
  general: {
    msgKey: 'error.general',
    message: 'We are sorry, we have encountered an unexpected error.',
  },
  backend: {
    msgKey: 'error.backend',
    message: 'Unable to retreive data. Please check your internet connection.',
  },

  /* Search */
  searchNoInput: {
    msgKey: 'error.search.noinput',
    message:
      'Enter at least {minNumChar} letters and you’ll start seeing facilities and addresses that match your input.',
  },

  /* Form Validation Fail */
  formValidationFail: {
    msgKey: 'error.form.validation.fail',
    message:
      'Some fields are missing or contain incorrect values. Please see below for more details.',
  },

  /* Cart Errors */
  cartCartProcessFail: {
    msgKey: 'error.cart.process.fail',
    message:
      'One or more reservations could not be completed! Unprocessed orders have been returned to your shopping cart.',
  },
  cartCartGeneral: {
    msgKey: 'error.cart.general',
    message: 'There are one or more problems in your shopping cart.',
  },
  cartOfferFail: {
    msgKey: 'labels_cart_offer_fail',
    message: 'Your special promotion order cannot be completed.',
  },
  cartMagazineOfferFail: {
    msgKey: 'labels_cart_magazine_offer_fail',
    message: 'Your magazine order cannot be completed.',
  },

  /* Print */
  printPermitFail: {
    msgKey: 'error.print.permit.fail',
    message: 'Print permit fail.',
  },
}

//Looks no code reference this variable, therefore comment it, in order to pass the husky check
//export const FormFaultFieldKey = '${msgparams.fieldname}'

export const FormCodes = {
  CFC0002: 'required',
  CFC0003: 'invalid',
  CFC0004: 'range',
  CFC0005: 'lessThan',
}
